export type ChatPanelTelemetryEvent =
  | { name: 'chat_panel_pinned' }
  | {
      name: 'chat_panel_unpinned';
      reason: 'user' | 'insufficient_width';
    }
  | {
      name: 'chat_panel_layout_failed';
      reason: 'insufficient_width';
    };

export type ChatPanelTelemetrySink = (
  event: ChatPanelTelemetryEvent
) => void;

let telemetrySink: ChatPanelTelemetrySink | undefined;

export const emitChatPanelTelemetry = (
  event: ChatPanelTelemetryEvent
): void => {
  try {
    telemetrySink?.(event);
  } catch {
    // Telemetry must never affect Chat presentation or shell layout.
  }
};

export const setChatPanelTelemetrySink = (
  sink?: ChatPanelTelemetrySink
): (() => void) => {
  telemetrySink = sink;
  return () => {
    if (telemetrySink === sink) telemetrySink = undefined;
  };
};
